// Toast
import store from 'app/store';
import AppToast from 'general/components/AppToast';
import DataCommonListener from 'general/listeners/DataCommonListener';
import React, { Suspense } from 'react';
import 'react-toastify/dist/ReactToastify.css';
// router
import AppDialog from 'general/components/AppDialog';
import GuestRoute from 'general/components/AppRoutes/GuestRoute';
import PrivateRoute from 'general/components/AppRoutes/PrivateRoute';
import { BrowserRouter, Link, Navigate, Route, Routes } from 'react-router-dom';
import KTPageError01 from 'general/components/OtherKeenComponents/KTPageError01';
import AppRoute from 'general/constants/AppRoute';
import ManagePaymentTransactions from 'features/ManagePaymentTransactions';
import Auth from 'features/Auth';
import ManageDealer from 'features/ManageDealer';
import ManageInvestor from 'features/ManageInvestor';
import InvestorReconciliationReport from 'features/InvestorReconciliationReport';
import ManageLandowner from 'features/ManageLandowner';
import LandownerReconciliationReport from 'features/LandownerReconciliationReport';
import AppDialogCustom from 'general/components/AppDialogCustom';
import ChargePointDetailScreen from 'features/FE/screens/ChargeConnectorDetailScreen';
import ChargePaymentQRScreen from 'features/FE/screens/ChargePaymentQRScreen';
import GuestPaymentRoute from 'general/components/AppRoutes/GuestPaymentRoute';
import ChargeTransactionDetailScreen from 'features/FE/screens/ChargeTransactionDetailScreen';
import InvestorGroupPackListScreen from 'features/ManageGroup/screens/InvestorGroupPackListScreen';
import InvestorGroupReconciliationReport from 'features/InvestorGroupReconciliationReport';
import AgencySaleAddOrderScreen from 'features/Agency/screens/AgencySaleAddOrderScreen';
import AgencySaleOrderListScreen from 'features/Agency/screens/AgencySaleOrderListScreen';
import ManageAgencyTransaction from 'features/ManageAgencyTransaction';
import ManageOrder from 'features/ManageOrder';
import AgencyContractListScreen from 'features/Agency/screens/AgencyContractListScreen';
import ManageSubAgencies from 'features/ManageSubAgencies';
import ManageTransactionHistory from 'features/ManageTransactionHistory';
import InvestorGroupPackHistory from 'features/InvestorGroupPackHistory';
import ElectricityPaymentHistory from 'features/ElectricityPaymentHistory';
import ManageCommissionTransaction from 'features/ManageCommissionTransaction';
import AgencyReconciliationListScreen from 'features/Agency/screens/AgencyReconciliationListScreen';
import AgencyConfigCommissionScreen from 'features/Agency/screens/AgencyConfigCommissionScreen';
import ManageGroup from 'features/ManageGroup';
import ChargeStation from 'features/Charge/ChargeStation';
import ChargeBrand from 'features/Charge/ChargeBrand';
import ChargeTransaction from 'features/Charge/ChargeTransaction';
import VehicleBrand from 'features/Charge/ChargeVehicleBrand';
import ChargeVehicle from 'features/Charge/ChargeVehicle';
import ChargeRfid from 'features/Charge/ChargeRFID';
import ChargeDriver from 'features/Charge/ChargeDriver';
import ChargePricing from 'features/Charge/ChargePricing';
import ChargeSystemLog from 'features/Charge/ChargeSystemLog';
import ChargeDriverTopUpHistoryScreen from 'features/Charge/ChargeDriver/screens/ChargeDriverTopUpHistoryScreen';
import ChargeDashboard from 'features/Charge/ChargeDashboard';
import ChargeStationMapScreen from 'features/Charge/ChargeStation/screens/ChargeStationMapScreen';
import ChargeStationIframeMapScreen from 'features/Charge/ChargeStation/screens/ChargeStationIframeMapScreen';
import Staff from 'features/System/Staff';
import AgencyDashboard from 'features/Agency/screens/AgencyDashboard';
import PoaContractListScreen from 'features/System/Contract/screens/PoaContractListScreen';
import ChargeSOC from 'features/Charge/ChargeSOC';
import Account from 'features/Account';
import DashboardRoute from 'general/components/AppRoutes/DashboardRoute';
import AdminDashboardRoute from 'general/components/AppRoutes/AdminDashboardRoute';
import PermissionGroup from 'features/System/PermissionGroup';
import PushNotification from 'features/System/PushNotification';
import EnergyBill from 'features/Charge/ChargeEnergyBill';
import AgencyWithdrawScreen from 'features/Agency/screens/AgencyWithdrawScreen';
import AgencySaleDetailScreen from 'features/Agency/screens/AgencySaleDetailScreen';
import { ChargeConstants } from 'features/Charge/chargeHelper';
import { AgencyConstants } from 'features/Agency/agencyHelper';
import ReconciliationReport from 'features/ReconciliationReport';
import GroupReconciliationReport from 'features/ReconciliationReport/GroupReconciliationReport';
import ManagePremises from 'features/ManagePremises';
import ChargeMaintain from 'features/Charge/ChargeMaintain';
import ChargeInstallation from 'features/Charge/ChargeInstallation';
import Tutorial from 'features/System/InstructionConfig';
import GeneralSetting from 'features/System/GeneralSetting/screens';
import AgencyPremiseOrderListScreen from 'features/Agency/screens/AgencyPremiseOrderListScreen';
import ChargePoint from 'features/Charge/ChargePoint';
import ChargeInventory from 'features/Charge/ChargeInventory';
import ManageChargePointPartner from 'features/ManageChargePointPartner';
import LandlordReconciliationReport from 'features/ReconciliationReport/LandlordReconciliationReport';
import ChargeDriverTopupDetailScreen from 'features/FE/screens/ChargeDriverTopupDetailScreen';
import DialogTopupCompletedScreen from 'features/FE/screens/DialogTopupCompletedScreen';
import ActionLog from 'features/System/ActionLog';
import MaintainerAuth from 'features/Maintainer/MaintainerAuth';
import MaintainerDashboard from 'features/Maintainer/MaintainerDashboard';
import MaintainerReconciliationReport from 'features/Maintainer/MaintainerReconciliationReport';
import MaintainerChargeStation from 'features/Maintainer/MaintainerChargeStation';
import MaintainerChargePoint from 'features/Maintainer/MaintainerChargePoint';
import MaintainerInfo from 'features/Maintainer/MaintainerInfo';
import MaintainerTicket from 'features/Maintainer/MaintainerTicket';

// Load BS
require('bootstrap/dist/js/bootstrap.min');
// Load KT plugins
require('assets/plugins/ktutil');
require('assets/plugins/ktmenu');
require('assets/plugins/ktoffcanvas');
require('assets/plugins/ktcookie');
require('assets/plugins/kttoggle');
// aside
require('assets/plugins/aside/aside');
require('assets/plugins/aside/aside-menu');
require('assets/plugins/aside/aside-toggle');
// header
require('assets/plugins/header/ktheader-mobile');
require('assets/plugins/header/ktheader-topbar');

window.$ = window.jQuery = require('jquery');
window.moment = require('moment');

function App() {
  return (
    <>
      {/* Router */}
      <BrowserRouter>
        {/* Suspense */}
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <DashboardRoute />
                </PrivateRoute>
              }
            />
            {/* auth */}
            <Route
              path={`${AppRoute.auth}/*`}
              element={
                <GuestRoute>
                  <Auth />
                </GuestRoute>
              }
            />

            {/* activate account */}
            <Route
              path={`${AppRoute.mobileApp}/*`}
              element={
                <GuestRoute>
                  <Account />
                </GuestRoute>
              }
            />

            <Route
              path={`${AppRoute.agencyApp}/*`}
              element={
                <GuestRoute>
                  <Account />
                </GuestRoute>
              }
            />

            {/* sac khong can tai khoan */}
            <Route path={`/prepaid/qr/:chargeConnectorSerial`} element={<ChargePointDetailScreen />} />
            <Route
              path="/prepaid/qr/payment"
              element={
                <GuestPaymentRoute>
                  <ChargePaymentQRScreen />
                </GuestPaymentRoute>
              }
            />
            <Route
              path="/prepaid/qr/transaction/:chargeTransactionId"
              element={
                <GuestPaymentRoute>
                  <ChargeTransactionDetailScreen />
                </GuestPaymentRoute>
              }
            />
            <Route
              path={`${AppRoute.dashboard}/*`}
              element={
                <PrivateRoute>
                  <AdminDashboardRoute>
                    <ChargeDashboard />
                  </AdminDashboardRoute>
                </PrivateRoute>
              }
            />
            <Route
              path={`${AppRoute.agencyDashboard}/*`}
              element={
                <PrivateRoute>
                  <AgencyDashboard />
                </PrivateRoute>
              }
            />
            <Route
              path={`${AppRoute.stationList}/*`}
              element={
                <PrivateRoute>
                  <ChargeStation />
                </PrivateRoute>
              }
            />
            <Route
              path={`${AppRoute.pointList}/*`}
              element={
                <PrivateRoute>
                  <ChargePoint />
                </PrivateRoute>
              }
            />
            {/* ban do tram sac */}
            <Route path={`${AppRoute.stationsMap}/*`} element={<ChargeStationMapScreen />} />
            <Route
              path={`${AppRoute.stationsMapIframe}/*`}
              element={<ChargeStationIframeMapScreen />}
            />

            {/* hoa don tien dien */}
            <Route path={`${AppRoute.energyBillList}/*`} element={<EnergyBill />} />

            {/* hoa don mat bang */}
            <Route path={`${AppRoute.premisesList}/*`} element={<ManagePremises />} />

            {/* bao tri tru sac */}
            <Route path={`${AppRoute.chargeMaintain}/*`} element={<ChargeMaintain />} />

            {/* lap dat tru sac */}
            <Route path={`${AppRoute.chargeInstallation}/*`} element={<ChargeInstallation />} />

            {/* quan ly phien sac */}
            <Route path={`${AppRoute.chargeTransactionList}/*`} element={<ChargeTransaction />} />
            {/* cau hinh thong bao gui */}
            <Route path={`${AppRoute.pushNotificationList}/*`} element={<PushNotification />} />
            <Route path={`${AppRoute.systemLogList}/*`} element={<ChargeSystemLog />} />
            <Route path={`${AppRoute.inventoryList}/*`} element={<ChargeInventory />} />
            <Route path={`${AppRoute.valuationList}/*`} element={<ChargePricing />} />
            <Route path={`${AppRoute.staffList}/*`} element={<Staff />} />
            <Route path={`${AppRoute.tutorialList}/*`} element={<Tutorial />} />
            <Route path={`${AppRoute.generalSetting}/*`} element={<GeneralSetting />} />
            <Route path={`${AppRoute.actionLogList}/*`} element={<ActionLog />} />
            {/* quan ly nhom quyen */}
            <Route
              path={`${AppRoute.staffPermissionList}/*`}
              element={<PermissionGroup />}
            />
            {/* quan ly nhom quyen sale */}
            <Route
              path={`${AppRoute.salePermissionList}/*`}
              element={
                <PermissionGroup
                  role={ChargeConstants.UserRole.AGENCY}
                  subRole={AgencyConstants.AgencyRole.SALE}
                />
              }
            />
            {/* quan ly nhom quyen doi tac */}
            <Route
              path={`${AppRoute.partnerPermissionList}/*`}
              element={
                <PermissionGroup
                  role={ChargeConstants.UserRole.AGENCY}
                  subRole={[
                    AgencyConstants.AgencyRole.GROUP,
                    AgencyConstants.AgencyRole.INVESTOR,
                    AgencyConstants.AgencyRole.LANDLORD,
                  ].join(',')}
                />
              }
            />
            {/* quan ly nhom quyen nha dau tu nhuong quyen*/}
            <Route
              path={`${AppRoute.manageGroupPermissionInvestor}/*`}
              element={<PermissionGroup />}
            />
            {/* quan ly nhom quyen nha dau tu HTKD*/}
            <Route
              path={`${AppRoute.manageGroupPermissionInvestorGroup}/*`}
              element={<PermissionGroup />}
            />
            {/* quan ly nhom quyen chu dat*/}
            <Route
              path={`${AppRoute.manageGroupPermissionLandlord}/*`}
              element={<PermissionGroup />}
            />
            {/* quan ly giao dich thanh toan */}
            <Route
              path={`${AppRoute.managePaymentTransactions}/*`}
              element={<ManagePaymentTransactions />}
            />
            {/* quan ly giao dich nap tien */}
            <Route
              path={`${AppRoute.customerTopUpHistory}/*`}
              element={<ChargeDriverTopUpHistoryScreen />}
            />
            {/* chi tra hoa hong */}
            <Route
              path={`${AppRoute.commissionTransactionList}/*`}
              element={<ManageCommissionTransaction />}
            />
            {/* quan ly giao dich dai ly */}
            <Route
              path={`${AppRoute.withdrawTransactionList}/*`}
              element={<ManageAgencyTransaction />}
            />
            {/* quan ly dai ly */}
            <Route path={`${AppRoute.saleList}/*`} element={<ManageDealer />} />
            <Route path={`${AppRoute.saleInfo}/*`} element={<ManageDealer isSaleInfo={true} />} />
            <Route path={`${AppRoute.subSaleList}/*`} element={<ManageSubAgencies role="SALE" />} />
            <Route
              path={`${AppRoute.transactionHistory}/*`}
              element={<ManageTransactionHistory />}
            />
            <Route path={`${AppRoute.saleHistory}/*`} element={<ManageDealer />} />
            <Route path={`${AppRoute.agencyAddOrder}`} element={<AgencySaleAddOrderScreen />} />
            <Route
              path={`${AppRoute.agencyAddOrder}/:saleId`}
              element={<AgencySaleDetailScreen showSidebar={true} />}
            />
            <Route path={`${AppRoute.orderList}/*`} element={<ManageOrder />} />
            <Route path={`${AppRoute.agencyOrderList}/*`} element={<ManageOrder />} />
            <Route path={`${AppRoute.purchaseOrder}/*`} element={<ManageOrder />} />
            <Route path={`${AppRoute.saleOrder}/*`} element={<ManageOrder />} />
            <Route path={`${AppRoute.customerList}/*`} element={<ChargeDriver />} />
            {/* quan ly nha dau tu */}
            <Route path={`${AppRoute.manageInvestor}/*`} element={<ManageInvestor />} />
            <Route path={`${AppRoute.investorList}/*`} element={<ManageInvestor />} />
            <Route
              path={`${AppRoute.groupList}/add-order`}
              element={<AgencySaleAddOrderScreen removeBaseLayout={false} />}
            />
            <Route path={`${AppRoute.groupList}/*`} element={<ManageGroup />} />
            <Route
              path={`${AppRoute.groupsList}/add-order`}
              element={<AgencySaleAddOrderScreen />}
            />
            <Route path={`${AppRoute.groupInfo}/*`} element={<ManageGroup isGroupInfo={true} />} />
            <Route
              path={`${AppRoute.subGroupList}/*`}
              element={<ManageSubAgencies role="GROUP" />}
            />

            <Route
              path={`${AppRoute.investorsReport}/*`}
              element={<InvestorReconciliationReport />}
            />
            <Route
              path={`${AppRoute.groupsReport}/*`}
              element={<InvestorGroupReconciliationReport />}
            />
            <Route
              path={`${AppRoute.groupReport}/*`}
              element={<GroupReconciliationReport />}
            />
            <Route
              path={`${AppRoute.investorInfo}/*`}
              element={<ManageInvestor isInvestorInfo={true} />}
            />
            <Route
              path={`${AppRoute.investmentPackList}/*`}
              element={<InvestorGroupPackListScreen />}
            />
            <Route path={`${AppRoute.groupPackHistory}/*`} element={<InvestorGroupPackHistory />} />
            {/* quan ly chu dat */}
            <Route path={`${AppRoute.landlordList}/*`} element={<ManageLandowner />} />
            <Route path={`${AppRoute.landlordInfo}/*`} element={<ManageLandowner isLandlordInfo={true} />} />
            <Route
              path={`${AppRoute.electricityPayment}/*`}
              element={<ElectricityPaymentHistory />}
            />
            <Route
              path={`${AppRoute.landlordsReport}/*`}
              element={<LandownerReconciliationReport />}
            />
            <Route
              path={`${AppRoute.landlordReport}/*`}
              element={<LandlordReconciliationReport />}
            />
            {/* quan ly doi tac mua tru sac */}
            <Route path={`${AppRoute.chargePointPartnerList}/*`} element={<ManageChargePointPartner />} />

            <Route path={`${AppRoute.manageVehicleBrand}/*`} element={<VehicleBrand />} />
            <Route path={`${AppRoute.vehicleList}/*`} element={<ChargeVehicle />} />
            <Route path={`${AppRoute.rfidList}/*`} element={<ChargeRfid />} />
            <Route path={`${AppRoute.manageChargeBrand}/*`} element={<ChargeBrand />} />
            <Route path={`${AppRoute.superDashboard}/*`} element={<ChargeSOC />} />
            {/* quybka */}
            {/* agency sale add order */}
            <Route path={`${AppRoute.agencySaleAddOrder}`} element={<AgencySaleAddOrderScreen />} />
            <Route
              path={`${AppRoute.agencySaleAddOrder}/:saleId`}
              element={<AgencySaleAddOrderScreen />}
            />
            <Route
              path={`${AppRoute.agencySaleOrderList}/*`}
              element={<AgencySaleOrderListScreen />}
            />
            <Route
              path={`${AppRoute.agencySaleOrderDetail}/:saleId`}
              element={<AgencySaleDetailScreen showSidebar={true} />}
            />
            <Route
              path={`${AppRoute.premiseOrderList}/*`}
              element={<AgencyPremiseOrderListScreen />}
            />
            <Route
              path={`${AppRoute.agencyContractList}/*`}
              element={<AgencyContractListScreen />}
            />
            {/* ds bao cao doi soat */}
            <Route
              path={`${AppRoute.agencyReconciliationList}`}
              element={<AgencyReconciliationListScreen />}
            />
            {/* cau hinh hoa hong */}
            <Route
              path={`${AppRoute.agencyConfigCommission}/*`}
              element={<AgencyConfigCommissionScreen />}
            />
            {/* hoa don tien dien */}
            <Route path={`${AppRoute.energyBillList}/*`} element={<EnergyBill />} />
            {/* danh sach hop dong */}
            <Route path={`${AppRoute.contractList}/*`} element={<AgencyContractListScreen />} />
            <Route path={`${AppRoute.poaContract}`} element={<PoaContractListScreen />} />
            <Route path={`${AppRoute.withdrawTransaction}/*`} element={<AgencyWithdrawScreen />} />
            {/* bao cao doi soat */}
            <Route path={`${AppRoute.reconciliationReport}/*`} element={<ReconciliationReport />} />
            {/* nap tien qua ma qr */}
            <Route path={`/topup/:serialNumber`} element={<ChargeDriverTopupDetailScreen />} />
            <Route
              path="/topup/:serialNumber/payment"
              element={
                <GuestPaymentRoute>
                  <ChargePaymentQRScreen />
                </GuestPaymentRoute>
              }
            />
            <Route path={`/payment/vnpay/completed`} element={<DialogTopupCompletedScreen />} />

            {/* ---- MAINTAINER ---- */}
            {/* Maintainer auth */}
            <Route
              path={`${AppRoute.maintainerAuth}/*`}
              element={
                <GuestRoute>
                  <MaintainerAuth />
                </GuestRoute>
              }
            />
            <Route
              path={`${AppRoute.maintainerApp}/*`}
              element={
                <GuestRoute>
                  <Account />
                </GuestRoute>
              }
            />
            <Route
              path={`${AppRoute.maintainerDashboard}/*`}
              element={
                <PrivateRoute>
                  <MaintainerDashboard />
                </PrivateRoute>
              }
            />
            <Route path={`${AppRoute.maintainerList}/*`} element={<MaintainerInfo />} />
            <Route path={`${AppRoute.maintainerInfo}/*`} element={<MaintainerInfo isMaintainerInfo={true} />} />
            <Route
              path={`${AppRoute.maintainerReport}/*`}
              element={<MaintainerReconciliationReport />}
            />
            <Route path={`${AppRoute.ticketList}/*`} element={<MaintainerTicket />} />
            <Route path={`${AppRoute.myTicket}/*`} element={<MaintainerTicket isMine={true} />} />
            <Route
              path={`${AppRoute.maintainerStationList}/*`}
              element={
                <PrivateRoute>
                  <MaintainerChargeStation />
                </PrivateRoute>
              }
            />
            <Route
              path={`${AppRoute.maintainerPointList}/*`}
              element={
                <PrivateRoute>
                  <MaintainerChargePoint />
                </PrivateRoute>
              }
            />
            <Route path={`${AppRoute.maintainerStationsMap}/*`} element={<ChargeStationMapScreen />} />
            <Route path="*" element={<KTPageError01 />} />
          </Routes>
        </Suspense>
      </BrowserRouter>

      {/* App Dialog */}
      <AppDialog />
      <AppDialogCustom />
      {/* Toast */}
      <AppToast />
      {/* Listener */}
      <DataCommonListener />

      {/* eKYC div */}
      <div id="eKYC_div"></div>
    </>
  );
}

export default App;
